export enum StartingPoint {
  MortgageIncrease = 'MortgageIncrease',
  Purchase = 'Purchase',
  MortgageTransfer = 'MortgageTransfer', //Oversluiten.
  InterestOnly = 'InterestOnly'
}

export enum StartingPointParam {
  MortgageIncrease = 'verhogen',
  Purchase = 'aankoop',
  MortgageTransfer = 'oversluiten',
  InterestOnly = 'revisie'
}
